// Core
import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';
import Button from 'components/commonComponents/Button';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogTitle from '@mui/material/DialogTitle';
import PropTypes from 'prop-types';
import InputField from 'components/commonComponents/InputField';
import { Alert, Snackbar } from '@mui/material';
import { restAPIs } from 'utils/restAPIs';
import { fetchData } from 'utils/fetch';

const WalletRedeem = (props) => {
  const { onClose, open, onRedeemed } = props;
  const { t } = useTranslation();
  const { userDetails, currentLang } = useSelector((store) => store.commonData);
  const [dataSet, setData] = useState({});
  const [error, setError] = useState({});
  const [isLoading, setIsLoading] = useState(false);
  const [errorAlert, setErrorAlert] = useState({ msg: '', key: Math.random(), open: false, severity: '' })
  const { fullname, email, phone } = dataSet;

  useEffect(() => {
    if (open) {
      setData({
        fullname: userDetails?.fullname || userDetails?.name || '',
        email: userDetails?.email || '',
        phone: userDetails?.phone || ''
      });
      setError({});
    }
  }, [open, userDetails]);

  const handleOnChange = (key) => (_value) => {
    if (_value) {
      setError({
        ...error,
        [key]: null
      });
    }
    setData({
      ...dataSet,
      [key]: _value
    });
  };

  const handleClose = (event, reason) => {
    if (reason === "backdropClick") {
      console.log(reason);
    } else {
      onClose();
    }
  };

  const handleSave = async () => {
    const errors = {
      fullname: !fullname,
      email: !email,
      phone: !phone,
    };

    setError(errors);
    let isFormValid = Object.values(errors).every((item) => !item);
    if (!isFormValid) return;
    setIsLoading(true);
    const formData = new FormData();
    formData.append('action', 'redeem');
    formData.append('appId', '29');
    formData.append('language', currentLang?.id);
    formData.append('fullname', fullname);
    formData.append('email', email);
    formData.append('phone', phone);
    const res = await fetchData(restAPIs.walletRedeem(formData));
    setIsLoading(false);
    if (res?.statusCode === 200) {
      setErrorAlert({ msg: res.errormessage || t('wallet_redeem_sent'), key: Math.random(), open: true, severity: 'success' });
      setTimeout(() => {
        setErrorAlert({ msg: '', key: Math.random(), open: false, severity: '' });
      }, 3000);
      onRedeemed && onRedeemed();
      onClose();
    } else {
      setErrorAlert({ msg: res?.errormessage || t('something_went_wrong_try_after_sometime'), key: Math.random(), open: true, severity: 'error' });
      setTimeout(() => {
        setErrorAlert({ msg: '', key: Math.random(), open: false, severity: '' });
      }, 3000);
    }
  };

  return (
    <>
      <Dialog
        open={open}
        onClose={handleClose}
        className='__common_model_class'
        maxWidth={'sm'}
        fullWidth={true}
        disableEscapeKeyDown
      >
        <DialogTitle id="alert-dialog-title">
          {t('redeem')}
        </DialogTitle>
        <DialogContent>
          <div className='mt-2'>
            <InputField
              onChange={handleOnChange('fullname')}
              value={fullname}
              placeholder={t('name')}
              type='text'
              label={t('name')}
              error={error.fullname}
            />
          </div>
          <div className='mt-2'>
            <InputField
              onChange={handleOnChange('email')}
              value={email}
              placeholder={t('email')}
              type='email'
              label={t('email')}
              error={error.email}
            />
          </div>
          <div className='mt-2'>
            <InputField
              onChange={handleOnChange('phone')}
              value={phone}
              placeholder={t('mobile_number')}
              type='text'
              label={t('mobile_number')}
              error={error.phone}
            />
          </div>
        </DialogContent>
        <DialogActions>
          <div className='d-flex align-items-center' style={{ margin: '15px' }}>
            <a onClick={() => handleClose(false)} style={{ cursor: 'pointer', margin: '0 10px' }}>{t('cancel')}</a>
            <Button
              withLoader
              loading={isLoading}
              disabled={isLoading}
              handleOnClick={handleSave}
              label={t('submit')}
            />
          </div>
        </DialogActions>
        {errorAlert && errorAlert.open ? <Snackbar open={errorAlert.open} autoHideDuration={3000} >
          <Alert severity={errorAlert.severity} sx={{ width: '100%' }}>
            {errorAlert.msg}
          </Alert>
        </Snackbar> : ''}
      </Dialog>
    </>
  );
};

export default WalletRedeem;

WalletRedeem.propTypes = {
  onClose: PropTypes.func,
  open: PropTypes.bool,
  onRedeemed: PropTypes.func,
};
